<template>
  <div class="row">
    <div class="col-lg-12">
      <div class="card">
        <div class="card-header py-4">
          <div class="row align-items-center">
            <div class="col-9 font-size-16" v-if="!item">Criar um novo Board</div>
            <div class="col-9 font-size-16" v-else>Editar um Board</div>
            <div class="col-3">
              <button
                type="button"
                class="btn btn-sm btn-info float-end"
                @click="$emit('handle2')"
              >Voltar</button>
            </div>
          </div>
        </div>
        <div class="card-body">
          <form @submit.prevent="onSubmit">
            <div class="row align-items-center">
              <div class="col-6">
                <app-input-text
                  v-model="propertie.name"
                  label="*Nome"
                  c_css
                  @input="checkFormFilled"
                />
                <app-input-select
                  :options="squads"
                  :disabled="false"
                  v-model="propertie.team_id"
                  label="*Squad"
                  @input="checkFormFilled"
                  c_css
                />
              </div>
              <div class="col-6">
                <app-textarea
                  v-model="propertie.description"
                  label="*Descrição"
                  c_css
                  @input="checkFormFilled"
                />
              </div>
            </div>
            <div class="row align-items-center">
              <div class="col-12 font-size-16 mb-2">Configurações do card padrão</div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="row">
                  <div class="col-12">
                    <app-input-text
                      v-model="propertie.card_name"
                      label="*Nome do modelo de card"
                      c_css
                      @input="checkFormFilled"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-8">
                    <app-input-search-add
                      label="*Selecione uma propriedade"
                      :items="properties"
                      @input="addPropertie"
                      c_css
                    />
                  </div>
                  <div class="col-4">
                    <button
                      type="button"
                      class="btn bg-soft-success text-succes"
                      @click="groupVueDraggable[0].items = properties"
                    >Adicionar todas</button>
                  </div>
                </div>

                <div class="row">
                  <div class="col-12 mt-3">
                    <button
                      type="submit"
                      class="btn btn-primary waves-effect waves-light"
                      :disabled="!isFormFilled"
                    >Salvar</button>
                    <span
                      class="badge rounded-pill bg-danger m-1"
                      v-if="message"
                    >*alterações não salvas</span>
                  </div>
                </div>
              </div>

              <div class="col-6" style="max-height:400px; overflow-y: auto">
                <properties-list :groups="groupVueDraggable" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AppInputText from "@/components/AppInputText/AppInputText.vue";
import AppTextarea from "@/components/AppTextarea/AppTextarea.vue";
import AppInputSelect from "@/components/AppInputSelect/AppInputSelect.vue";
import AppInputSearchAdd from "@/components/AppInputSearchAdd/AppInputSearchAdd.vue";
//import AppInputTextAdd from "@/components/AppInputTextAdd/AppInputTextAdd.vue";
//import AppButtonDeleteConfirm from "@/components/AppButtonDeleteConfirm/AppButtonDeleteConfirm.vue";
import PropertiesList from "./Properties.vue";
import { mapActions } from "vuex";
export default {
  props: {
    item: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    AppInputText,
    AppInputSelect,
    AppTextarea,
    AppInputSearchAdd,
    PropertiesList
    //AppInputTextAdd,
    //AppButtonDeleteConfirm
  },
  data() {
    return {
      isFormFilled: false,
      propertie: {
        name: null,
        team_id: null,
        description: null,
        card_name: null,
        items: []
      },
      groupVueDraggable: [
        {
          id: 1,
          name: "Propriedades",
          items: []
        }
      ],
      properties: [],
      squads: [],
      message: false,
      selected: {}
    };
  },
  computed: {
    alertMessage() {
      return "";
    },
    toggleActive() {
      return {
        active: this.isActive,
        "toggle-on": this.isActive,
        "toggle-off": !this.isActive
      };
    }
  },
  mounted() {
    this.getAllProperties();
    this.getAllSquads();
  },
  methods: {
    ...mapActions([
      "showMessage",
      "showLoader",
      "setLoaderTitle",
      "showBlockScreen"
    ]),
    removePropertie(id) {
      let temp = this.propertie.items.filter(el => el.id != id);
      this.propertie.items = temp;
    },
    addPropertie(id) {
      if (this.groupVueDraggable[0].items.some(p => p.id === id)) return;
      let data = this.properties.filter(value => value.id === id);
      this.groupVueDraggable[0].items.push(...data);
    },
    countValidValues() {
      if (Object.keys(this.propertie.values).length === 0) {
        return 0;
      }
      return this.propertie.values.filter(item => !item.status === false)
        .length;
    },
    getAllProperties() {
      let _this = this;
      let headers = _this.$getAPIHeaders("GET", `propertie`);
      this.axios(headers)
        .then(function(response) {
          _this.setProperties(response.data.data.data);
        })
        .catch(function(error) {
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    setProperties(data) {
      const simplifiedData = data.map((item, index) => ({
        id: item.id,
        name: item.name,
        order: index + 1
      }));
      this.properties = simplifiedData;
    },
    setSquads(data) {
      const simplifiedData = data.map(item => {
        return {
          value: item.id,
          text: item.name
        };
      });
      this.squads = simplifiedData;
    },
    getAllSquads() {
      let _this = this;
      let headers = _this.$getAPIHeaders("GET", `team`);
      this.axios(headers)
        .then(function(response) {
          _this.setSquads(response.data.data.data);
        })
        .catch(function(error) {
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    onSubmit() {
      let _this = this;
      //_this.showLoader(true);
      const data = _this.propertie;
      data.items = _this.groupVueDraggable[0].items;
      let headers = _this.$getAPIHeaders("POST", `board`, data);
      this.axios(headers)
        .then(function(response) {
          _this.showLoader(false);
          _this.showMessage({
            title: response.data.message,
            css: "bg-success"
          });
          _this.onAction(response.data.data);
        })
        .catch(function(error) {
          _this.showLoader(false);
          _this.showMessage({
            title: error.response.data.message,
            text: _this.$root.$options.filters.objectError(
              error.response.data.errors
            ),
            css: "bg-danger"
          });
        });
    },
    onAction(data) {
      this.$emit("handle", data);
    },
    checkFormFilled() {
      this.isFormFilled =
        this.propertie.name !== null && this.propertie.team_id !== null;
    }
  }
};
</script>